<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="page-title">
                    <h5>{{ 'sales.details_title' | translate }}</h5>
                </div>

                <div *ngIf="loading" class="text-center py-5">
                    {{ 'common.loading' | translate }} ...
                </div>

                <div *ngIf="error && !loading" class="alert alert-danger">
                    {{ 'sales.load_error' | translate }}
                </div>

                <div *ngIf="!loading && !error && sale" class="card sale-detail-card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">{{ 'sales.details_title' | translate }}</h5>
                        <button class="btn-action btn-back" (click)="goBack()">
                            <i class="fas fa-arrow-left"></i>
                            {{ 'common.back' | translate }}
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.ref' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.ref || '-' }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.date' | translate }}</label>
                                <p class="form-control-plaintext">{{ formatDate(sale.createdAt) }}</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.qty' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.qty }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.price' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.price | number }} F</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.discount' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.discount || '-' }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.status' | translate }}</label>
                                <p class="form-control-plaintext">
                                    <span [class]="getStatusClass(sale.status)">{{ getStatusLabel(sale.status) | translate }}</span>
                                </p>
                            </div>
                        </div>

                        <h6 class="section-title">{{ 'sales.product_info' | translate }}</h6>
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.product' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.product?.productName || '-' }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.category' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.product?.category?.name || '-' }}</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.condition' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.product?.productCondition?.description || '-' }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.measurement' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.product?.measurementUnit?.description || '-' }}</p>
                            </div>
                        </div>

                        <h6 class="section-title">{{ 'sales.customer_info' | translate }}</h6>
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.customer' | translate }}</label>
                                <p class="form-control-plaintext">{{ getCustomerName() }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.phone' | translate }}</label>
                                <p class="form-control-plaintext">{{ getCustomerPhone() }}</p>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.email' | translate }}</label>
                                <p class="form-control-plaintext">{{ getCustomerEmail() }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.city' | translate }}</label>
                                <p class="form-control-plaintext">{{ getCustomerCity() }}</p>
                            </div>
                        </div>

                        <h6 class="section-title" *ngIf="sale.logisticDetails">{{ 'sales.logistic_info' | translate }}</h6>
                        <div class="row mb-3" *ngIf="sale.logisticDetails">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.logistic_agent' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.logisticDetails.logisticAgent || '-' }}</p>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.delivery_ref' | translate }}</label>
                                <p class="form-control-plaintext">{{ sale.logisticDetails.deliveringRef || '-' }}</p>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="sale.logisticDetails">
                            <div class="col-md-6">
                                <label class="form-label fw-bold">{{ 'sales.delivery_status' | translate }}</label>
                                <p class="form-control-plaintext">
                                    <span [class]="getStatusClass(sale.logisticDetails.deliveryStatus)">
                                        {{ getLogisticStatusLabel(sale.logisticDetails.deliveryStatus) | translate }}
                                    </span>
                                </p>
                            </div>
                            <div class="col-md-6" *ngIf="sale.logisticDetails.deliveryAddress">
                                <label class="form-label fw-bold">{{ 'sales.delivery_address' | translate }}</label>
                                <p class="form-control-plaintext">
                                    {{ sale.logisticDetails.deliveryAddress.addressLine1 }},
                                    {{ sale.logisticDetails.deliveryAddress.town }}
                                </p>
                            </div>
                        </div>

                        <h6 class="section-title">{{ 'sales.update_status' | translate }}</h6>
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <select [(ngModel)]="selectedStatus" class="form-select" [disabled]="updating">
                                    <option value="" disabled>{{ 'sales.select_status' | translate }}</option>
                                    <option [value]="sale.status" disabled *ngIf="sale.status && !isCurrentStatusChangeable()">
                                        {{ getStatusLabel(sale.status) | translate }}
                                    </option>
                                    <option *ngFor="let status of getUpdateStatusOptions()" [value]="status">
                                        {{ 'sales.status_' + status.toLowerCase() | translate }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <input [(ngModel)]="description" class="form-control"
                                       [placeholder]="'sales.description' | translate" [disabled]="updating">
                            </div>
                            <div class="col-md-auto">
                                <button (click)="updateStatus()" class="btn btn-success text-nowrap"
                                        [disabled]="updating || !selectedStatus">
                                    <span *ngIf="updating" class="spinner-border spinner-border-sm me-1"></span>
                                    {{ 'sales.update_status' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>
